import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity from "entity";

export default class Safra extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/GrCm9qksrk9DjzgzLEq4/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO");
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "safra";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 1, filter: true },
            {
                field: "status", headerName: "Status", flex: 1, filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO"])
            },
            { field: "safra", headerName: "Safra", flex: 2, filter: true },
        ];
    }
}
